import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
	id: '',
	deleteList: [],
	checkedList: [],
	showdetails: false,
};

const studentSlice = createSlice({
	name: 'studentDetail',
	initialState,
	reducers: {
		studentID: (state, action) => {
			state.id = action.payload;
			console.log('settrainingCenterID', state.id);
		},
		showStudentDetails: (state, action) => {
			// console.log('Cake Action :', action);
			state.showdetails = action.payload;
		},
		setdeleteList: (state, action) => {
			state.deleteList = [...state.deleteList, action.payload];
		},
		setemptyDeleteList: (state) => {
			state.deleteList = [];
		},
		setfliterDeleteList: (state, action) => {
			state.deleteList = action.payload;
		},
		setcheckedList: (state, action) => {
			// console.log('reduxAction', action.payload);
			state.checkedList = [...state.checkedList, action.payload];
			// console.log('payloadSet', state.checkedList);
		},
		setemptycheckedList: (state, action) => {
			state.checkedList = [];
		},
		setflitercheckedList: (state, action) => {
			state.checkedList = action.payload;
		},
	},
});

export const {
	studentID,
	showStudentDetails,
	setdeleteList,
	setcheckedList,
	setemptyDeleteList,
	setfliterDeleteList,
	setflitercheckedList,
	setemptycheckedList,
} = studentSlice.actions;

export const studentReducer = {
	// studentID: studentID.reducer,
	showStudentDetails: studentSlice.reducer,
};
